import React from 'react';
import CrossingInWardReport from '../CrossingInwardReport';
import CrossingInWardReportForBBAC from '../CrossingInWardReportForBBAC';

export default function CrossingInWardReportPage({ sessionObject }) {
  const client = process.env.REACT_APP_CLIENT;

  if (client === "bbac") {
    return (
      <div className="page-bilty">
        <CrossingInWardReportForBBAC sessionObject={sessionObject} />
      </div>
    );
  }

  return (
    <div className="page-bilty">
      <CrossingInWardReport sessionObject={sessionObject} />
    </div>
  );
}